import React, { ChangeEvent } from "react";

import { cn } from "@/lib/utils";
import { IAsset } from "@api/IWalletController";

import MemeInput from "@components/ui/meme-input";

interface AddressInputProps {
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    name?: string;
    required?: boolean;
    className?: string;
    label?: string;
    asset?: IAsset;
}

const AddressInput: React.FC<AddressInputProps> = ({
    value,
    onChange,
    placeholder = "Enter address",
    name = "address",
    required = false,
    className,
    label = "Address token/wallet",
    asset,
}) => {
    // Local state for MemeSwitch (for test/demo)

    return (
        <div className={cn("flex flex-col gap-3", className)}>
            {label && <div className="text-sm font-medium">{label}</div>}
            <div className="flex items-center gap-2 relative">
                <MemeInput
                    placeholder={placeholder}
                    name={name}
                    required={required}
                    value={value}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

export default AddressInput;
